export { default as Icon } from './Icon.component'
export * from './icons'
